// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"Support_pageHolder__3f2C0","imageHolder":"Support_imageHolder__2rDh9","newChatBtn":"Support_newChatBtn__V-qyb","SupportCallHolder":"Support_SupportCallHolder__1VA19"};